import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject2(): Promise<void> {
  await Excel.run(async (context) => {
    // SHEET 1 - Mercado Agricultores
    await safeDeleteSheet(context, "Mercado Agricultores");
    const sheet = context.workbook.worksheets.add("Mercado Agricultores");

    const data: (string | number)[][] = [
      ["Fecha USA:", "25/04/2025", "Ventas al Mercado de Agricultores", "Fecha Europea:", "25/04/2025"],
      ["Codigo", "Ubicacion", "Producto", "Temporada", "Ventas"],
      [10, "Centro de la ciudad", "Panes y Pasteles", "Primavera", 150059],
      [10, "Centro de la ciudad", "Panes y Pasteles", "Verano", 150527],
      [10, "Centro de la ciudad", "Panes y Pasteles", "Otono", 126750],
      [10, "Centro de la ciudad", "Lacteos, Huevos y Miel", "Primavera", 65000],
      [10, "Centro de la ciudad", "Lacteos, Huevos y Miel", "Verano", 50000],
      [10, "Centro de la ciudad", "Lacteos, Huevos y Miel", "Otono", 63000],
      [10, "Centro de la ciudad", "Fruta", "Primavera", 205129],
      [10, "Centro de la ciudad", "Fruta", "Verano", 201696],
      [10, "Centro de la ciudad", "Fruta", "Otono", 239610],
      [10, "Centro de la ciudad", "Carne", "Primavera", 162580],
      [10, "Centro de la ciudad", "Carne", "Verano", 169930],
      [10, "Centro de la ciudad", "Carne", "Otono", 170500],
      [10, "Centro de la ciudad", "Vegetales", "Primavera", 305714],
      [10, "Centro de la ciudad", "Vegetales", "Verano", 408605],
      [10, "Centro de la ciudad", "Vegetales", "Otono", 350550],
      [20, "Parque ladera", "Panes y Pasteles", "Primavera", 14800],
      [20, "Parque ladera", "Panes y Pasteles", "Verano", 19200],
      [20, "Parque ladera", "Panes y Pasteles", "Otono", 14430],
      [20, "Parque ladera", "Fruta", "Primavera", 57800],
      [20, "Parque ladera", "Fruta", "Verano", 59200],
      [20, "Parque ladera", "Fruta", "Otono", 57200],
      [20, "Parque ladera", "Carne", "Primavera", 16200],
      [20, "Parque ladera", "Carne", "Verano", 17500],
      [20, "Parque ladera", "Carne", "Otono", 18300],
      [20, "Parque ladera", "Vegetales", "Primavera", 32500],
      [20, "Parque ladera", "Vegetales", "Verano", 72900],
      [20, "Parque ladera", "Vegetales", "Otono", 63700],
      [30, "Parque norte", "Panes y Pasteles", "Primavera", 66384],
      [30, "Parque norte", "Panes y Pasteles", "Verano", 79656],
      [30, "Parque norte", "Panes y Pasteles", "Otono", 55400],
      [30, "Parque norte", "Lacteos, Huevos y Miel", "Primavera", 9415],
      [30, "Parque norte", "Lacteos, Huevos y Miel", "Verano", 10024],
      [30, "Parque norte", "Lacteos, Huevos y Miel", "Otono", 10450],
      [30, "Parque norte", "Fruta", "Primavera", 80265],
      [30, "Parque norte", "Fruta", "Verano", 96194],
      [30, "Parque norte", "Fruta", "Otono", 80280],
      [30, "Parque norte", "Carne", "Primavera", 47951],
      [30, "Parque norte", "Carne", "Verano", 46827],
      [30, "Parque norte", "Carne", "Otono", 38492],
      [30, "Parque norte", "Vegetales", "Primavera", 170320],
      [30, "Parque norte", "Vegetales", "Verano", 350991],
      [30, "Parque norte", "Vegetales", "Otono", 161940],
      [40, "Parque a la orilla", "Panes y Pasteles", "Primavera", 27200],
      [40, "Parque a la orilla", "Panes y Pasteles", "Verano", 37520],
      [40, "Parque a la orilla", "Panes y Pasteles", "Otono", 29280],
      [40, "Parque a la orilla", "Lacteos, Huevos y Miel", "Primavera", 28100],
      [40, "Parque a la orilla", "Lacteos, Huevos y Miel", "Verano", 39055],
      [40, "Parque a la orilla", "Lacteos, Huevos y Miel", "Otono", 29070],
      [40, "Parque a la orilla", "Carne", "Primavera", 60123],
      [40, "Parque a la orilla", "Carne", "Verano", 80230],
      [40, "Parque a la orilla", "Carne", "Otono", 71190],
      [40, "Parque a la orilla", "Vegetales", "Primavera", 132050],
      [40, "Parque a la orilla", "Vegetales", "Verano", 141930],
      [40, "Parque a la orilla", "Vegetales", "Otono", 114860],
      [50, "Parque del valle", "Panes y Pasteles", "Primavera", 44188],
      [50, "Parque del valle", "Panes y Pasteles", "Verano", 77383],
      [50, "Parque del valle", "Panes y Pasteles", "Otono", 62615],
      [50, "Parque del valle", "Lacteos, Huevos y Miel", "Primavera", 4310],
      [50, "Parque del valle", "Lacteos, Huevos y Miel", "Verano", 5203],
      [50, "Parque del valle", "Lacteos, Huevos y Miel", "Otono", 4356],
      [50, "Parque del valle", "Fruta", "Primavera", 75491],
      [50, "Parque del valle", "Fruta", "Verano", 117829],
      [50, "Parque del valle", "Fruta", "Otono", 75752],
      [50, "Parque del valle", "Carne", "Primavera", 26551],
      [50, "Parque del valle", "Carne", "Verano", 40065],
      [50, "Parque del valle", "Carne", "Otono", 15153],
      [50, "Parque del valle", "Vegetales", "Primavera", 71072],
      [50, "Parque del valle", "Vegetales", "Verano", 80273],
      [50, "Parque del valle", "Vegetales", "Otono", 79877],
      [60, "Lago oeste", "Panes y Pasteles", "Primavera", 177196],
      [60, "Lago oeste", "Panes y Pasteles", "Verano", 220909],
      [60, "Lago oeste", "Panes y Pasteles", "Otono", 197112],
      [60, "Lago oeste", "Lacteos, Huevos y Miel", "Primavera", 40272],
      [60, "Lago oeste", "Lacteos, Huevos y Miel", "Verano", 49312],
      [60, "Lago oeste", "Lacteos, Huevos y Miel", "Otono", 52732],
      [60, "Lago oeste", "Fruta", "Primavera", 110511],
      [60, "Lago oeste", "Fruta", "Verano", 119349],
      [60, "Lago oeste", "Fruta", "Otono", 110485],
      [60, "Lago oeste", "Carne", "Primavera", 39516],
      [60, "Lago oeste", "Carne", "Verano", 53804],
      [60, "Lago oeste", "Carne", "Otono", 40458],
      [60, "Lago oeste", "Vegetales", "Primavera", 85024],
      [60, "Lago oeste", "Vegetales", "Verano", 116343],
      [60, "Lago oeste", "Vegetales", "Otono", 114058],
    ];

    const totalRows = data.length;
    sheet.getRangeByIndexes(0, 0, totalRows, 5).values = data;
    sheet.getRangeByIndexes(0, 0, 2, 5).format.fill.color = "#F1CBF0";
    const rangoFiltrado = sheet.getRangeByIndexes(1, 0, totalRows - 1, 5);
    sheet.autoFilter.apply(rangoFiltrado);
    sheet.getRange(`E3:E${totalRows}`).numberFormat = [["$#,##0"]];
    sheet.getUsedRange().format.autofitColumns();
    sheet.getUsedRange().format.autofitRows();
    sheet.getRange("A1").select();

    // SHEET 2 - Ingresos de Alquiler
    await safeDeleteSheet(context, "Ingresos de Alquiler");
    const hoja2 = context.workbook.worksheets.add("Ingresos de Alquiler");

    const datos: (string | number)[][] = [
      ["Alquiler del Espacio de Mercado de los Granjeros", "", "", "", "", "", "", ""],
      ["", "Centro de la ciudad", "Parque ladera", "Parque norte", "Parque a la orilla", "Parque del valle", "Lago oeste", "Total"],
      ["Ingresos (actuales):", 48000, 9600, 24000, 14400, 14400, 28800, 139200],
      ["Cantidad de Espacios Disponibles:", 100, 20, 50, 30, 30, 60, 290],
      ["Numero de Sabados de Mercado:", 24, 24, 24, 24, 24, 24, 24],
      ["Precio de Alquiler:", 20, 20, 20, 20, 20, 20, 20],
      ["Ingresos Proyectados (proximo ano):", "", "", "", "", "", "", ""],
    ];

    hoja2.getRangeByIndexes(0, 0, datos.length, 8).values = datos;
    hoja2.getRange("A1:H1").merge();
    hoja2.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { size: 14, bold: true },
    });
    hoja2.getRange("A1:H2").format.fill.color = "#F1CBF0";

    ["3", "6", "7"].forEach((f) =>
      hoja2.getRange(`B${f}:H${f}`).numberFormat = [["$#,##0.00"]]
    );

    hoja2.getRange("B7").formulas = [["=B4*B5*B6"]];
    hoja2.getRange("C7").formulas = [["=C4*C5"]]; // intentional error
    hoja2.getRange("D7").formulas = [["=D4*D5*D6"]];
    hoja2.getRange("E7").formulas = [["=E4*E5*E6"]];
    hoja2.getRange("F7").formulas = [["=F4*F5*F6"]];
    hoja2.getRange("G7").formulas = [["=G4*G5*G6"]];
    hoja2.getRange("H7").formulas = [["=H4*H5*H6"]];

    hoja2.getUsedRange().format.autofitColumns();
    hoja2.getUsedRange().format.autofitRows();

    const rango = hoja2.getRange("A2:H7");
    const bordes = rango.format.borders;
    (["EdgeTop", "EdgeBottom", "EdgeLeft", "EdgeRight", "InsideHorizontal", "InsideVertical"] as const).forEach((id) => {
      const b = bordes.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    // SHEET 3 - Pivot Table
    await safeDeleteSheet(context, "Ventas Proyectadas (Prox. ano)");
    const pvSheet = context.workbook.worksheets.add("Ventas Proyectadas (Prox. ano)");
    pvSheet.getRange("A1:C1").merge();
    pvSheet.getRange("A1").values = [["Resumen del Mercado de Agricultores"]];
    pvSheet.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 14 },
    });

    const srcSheet = context.workbook.worksheets.getItem("Mercado Agricultores");
    const srcRange = srcSheet.getRange("A2:E86");
    const pvt = pvSheet.pivotTables.add("pvtVentas", srcRange, pvSheet.getRange("A2"));

    pvt.hierarchies.load("items/name");
    await context.sync();

    pvt.rowHierarchies.add(pvt.hierarchies.getItem("Ubicacion"));
    pvt.rowHierarchies.add(pvt.hierarchies.getItem("Producto"));
    pvt.dataHierarchies.add(pvt.hierarchies.getItem("Ventas"));

    pvSheet.getUsedRange().format.autofitColumns();
    pvSheet.activate();
  });
}
